import { FC, ReactNode } from 'react';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import { CloseModalButton } from '../../../../../components/close-modal-button/index';
import { ModalWrapper } from '../../../../../components/modal-wrapper/index';
import { StringKey } from '../../../../../lang/index';
import { FormMode, TemplateFormStore } from '../../store/template-form.store';
import { AddTemplateForm } from './add-template/add-template-form';
import { EditTemplate } from './edit-template/edit-template';
import { ViewTemplate } from './view-template';

const modeTitleKey: Record<FormMode, StringKey> = {
  [FormMode.ADD_TEMPLATE]: 'ADD_TEMPLATE',
  [FormMode.EDIT_TEMPLATE]: 'EDIT_TEMPLATE',
  [FormMode.VIEW_TEMPLATE]: 'VIEW_TEMPLATE',
};

const formContentByMode: Record<FormMode, ReactNode> = {
  [FormMode.ADD_TEMPLATE]: <AddTemplateForm />,
  [FormMode.EDIT_TEMPLATE]: <EditTemplate />,
  [FormMode.VIEW_TEMPLATE]: <ViewTemplate />,
};

export const FormModal: FC = () => {
  const toggleState = TemplateFormStore(({ toggleState }) => toggleState);
  const isOpen = TemplateFormStore(({ isOpen }) => isOpen);
  const mode = TemplateFormStore(({ mode }) => mode);

  return (
    <ModalWrapper
      className="w-full max-w-[485px] p-1"
      control={{ open: isOpen }}
      onBgClick={() => toggleState(false)}
      side="RIGHT"
    >
      <div className="flex h-full w-full flex-col overflow-hidden rounded-lg">
        <div className="flex w-full items-center justify-between bg-white px-6 pt-3">
          <span className="text-xl font-semibold text-gray-700">
            <AppFormattedMessage id={modeTitleKey[mode]} />
          </span>
          <CloseModalButton onClose={() => toggleState(false)} />
        </div>
        {formContentByMode[mode]}
      </div>
    </ModalWrapper>
  );
};
